import { render, staticRenderFns } from "./withdrawal-success.vue?vue&type=template&id=7dc6c00f&scoped=true"
import script from "./withdrawal-success.vue?vue&type=script&lang=js"
export * from "./withdrawal-success.vue?vue&type=script&lang=js"
import style0 from "./withdrawal-success.vue?vue&type=style&index=0&id=7dc6c00f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc6c00f",
  null
  
)

export default component.exports